import { render, staticRenderFns } from "./organiz_details.vue?vue&type=template&id=3e43e76f&scoped=true&"
import script from "./organiz_details.vue?vue&type=script&lang=js&"
export * from "./organiz_details.vue?vue&type=script&lang=js&"
import style0 from "./organiz_details.vue?vue&type=style&index=0&id=3e43e76f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e43e76f",
  null
  
)

export default component.exports